'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResourcePath = undefined;

var _constants = require('./constants');

var _isomorphicHelpers = require('./isomorphic-helpers');

var getResourcePath = exports.getResourcePath = function getResourcePath(path) {
  if ((0, _isomorphicHelpers.isServerSide)()) {
    return '/' + path.replace(/^\//, '');
  }
  var BASE_URL = window.location.href.includes('localhost') && _constants.LOCAL_BASE_URL || '';
  return BASE_URL + '/' + path.replace(/^\//, '');
};